export default __webpack_public_path__ + "c76b9b77d5004eebc4d1070418fb38d1.jpg";